<div class="custom-background" [ngStyle]="{ 'background-image': 'url(./assets/images/fondo-login.jpg)' }">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-6">
        <div class="custom-error">
          <h1 class="custom-h1">404</h1>
          <h3 class="custom-h3">Página no encontrada</h3>
          <p class="custom-p">Parece que estás intentando acceder a un contenido que no existe.</p>
          <p class="custom-p">Revisa la dirección para ver si es correcta o explora el sitio en busca de lo que necesitas.</p>
          <section class="back-proplum" role="login">
            <a routerLink="/dashboard" class="btn_gratis">Ir al inicio</a>
          </section>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>
        &copy; <br />
        {{ dateTime.getFullYear() }} <br />
        Todos los derechos reservados
      </p>
    </div>
  </div>
</div>
